import React, { Component } from "react";
import { connect } from "react-redux";
import { changeInPredictAction, changeInExeWaitngAction, changeWaitngTimeAction } from "../../redux/app/actions";
import { changeDsAction as changeCsLineDsAction } from "../../redux/csLine/actions";
import { changeDsAction as changeResultDsAction } from "../../redux/csDsp/actions";

export const divNumOpt = [10, 20, 30, 50, 70, 100];

const mapStateToProps = state => {
  return {
    swMode: state.appReducer.swMode,
    csLineDs: state.csLineReducer.dataset,
    resultDs: state.csDspReducer.data,
    ds: state.geoReducer.dataset,
    coord: state.modelAreaReducer.coord,
    userLicense: state.appReducer.userLicense,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.minDivL = null;
    this.doExe = this.doExe.bind(this);
    this.changeDivNum = this.changeDivNum.bind(this);
    this.state = {
      useModel: 0,
    };
  }

  /*
   * 分割数変更
   * @param {Number} index フィールドの行インデックス
   * @param {Event} e イベント情報
   * @since hara 2020-10-05
   */
  changeDivNum(index, e) {
    const csLineDs = [...this.props.csLineDs];
    csLineDs[index]["divNum"] = e.target.value;
    csLineDs[index]["estFlg"] = 0; //未推定に変更
    this.props.dispatch(changeCsLineDsAction(csLineDs));
  }

  /*
   * 推定実行
   * @since kawai 2020-09-15
   */
  async doExe() {
    //断面ラインが登録されていなければ、予測をスキップ
    if (!this.props.csLineDs.length) return;

    let lines = [];
    //未推定の断面ラインをlinesとして抽出
    this.props.csLineDs.forEach(line => {
      if (line.estFlg === 0) {
        //未推定の場合
        //linesに「divNumOptの列番号」から「分割数」を算出し、格納する
        line["csLineDs"] = divNumOpt[line["divNum"]];
        lines = lines.concat(line);
        console.log(`predict ${line["ID"]}.`);
      } else {
        console.log(`SKIP ${line["ID"]}. CSDsp of ID[${line["ID"]}] already exists.`);
      }
    });

    //予測済みの断面ラインしか存在しなければ、予測をスキップ
    if (lines.length === 0) {
      alert("予測は完了しています。");
      return;
    }

    //ローダーの表示・非表示切替
    const waiting = stat => {
      this.props.dispatch(changeInPredictAction(stat));
    };
    waiting(true);
    await this.doCheckExe();
    const ds = this.props.ds[0]; //デフォルトの地質データを送る
    console.log("geo");
    console.log(ds.geo);

    let cslines = {
      lines: lines,
      type: "line",
      geo: ds.geo,
      range: {
        x1: this.props.coord[2],
        x2: this.props.coord[3],
        y1: this.props.coord[1],
        y2: this.props.coord[0],
      },
      exe: "predict",
      model: this.state.useModel,
    };
    console.log("cslines:" + JSON.stringify(cslines));

    //サーバに断面ラインデータを送信し、予測結果を受け取る
    //TODO:userIDは暫定で0としている。ユーザログイン機能が実装されたら可変とする
    const origin = window.location.origin;
    const search = window.location.search;
    await fetch(`${origin}/api/0/predict/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cslines),
    })
      .then(response => response.json())
      .then(results => {
        if (results.result == "limit") {
          alert("現在サーバーが混み合っております。時間を空けて再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (results.result === "timeout") {
          alert("タイムアウトエラーが発生しました。分割数を小さくし、再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          const csLineDs = [...this.props.csLineDs];
          results.forEach(result => {
            console.log(`result[${result["ID"]}] received`);
            this.props.dispatch(changeResultDsAction(result["data"], result["ID"]));
            csLineDs[result["ID"] - 1]["estFlg"] = 1; //推定済みに変更
          });
          this.props.dispatch(changeCsLineDsAction(csLineDs));
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time));
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }

  render() {
    return (
      <div>
        <div className="TWrap js-scroll" style={{ overflowY: "scroll" }}>
          <table className="autoTable">
            <thead>
              <tr>
                <th>断面ラインID</th>
                <th className="tsM">断面ライン名称</th>
                <th className="tsM">分割数 (目安)</th>
              </tr>
            </thead>
            <tbody>
              {this.props.csLineDs.map((el, index) => (
                <tr key={el.ID}>
                  <td>{el.ID}</td>
                  <td>{window.abbreText(el.name, 18)}</td>
                  <td>
                    <select className="selectT" defaultValue={el.divNum} value={el.divNum} onChange={e => this.changeDivNum(index, e)}>
                      {divNumOpt.map((el, index) => (
                        <option value={index} key={index}>
                          {el}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="l-right l-mtM">
          {this.props.userLicense == 0 && (
            <div className="">
              <label htmlFor="autoScrChk"></label>
              モデル：
              <select
                className="selectM"
                onChange={e =>
                  this.setState({
                    useModel: e.target.value,
                  })
                }>
                <option value="1"></option>
                <option value="2">旧地形</option>
                <option value="3">現地形+層厚</option>
                <option value="4">旧地形+層厚</option>
              </select>
            </div>
          )}
          <button className="cBtn" onClick={this.doExe}>
            実行
          </button>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
